export function hideEventBlock() {
    $('.event-block .close').on('click', function () {
        $(this).parent().slideUp();
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/hideEventBlock.js